import * as React from 'react';
import { useContext } from 'react';

type TranslationsNotificationBannerContextType = {
  showBanner: boolean;
  setHideBanner: (show: boolean) => void;
  openDialog: () => void;
  productType: string;
  subfolderLanguage: string;
  hasTranslations: boolean;
};

const TranslationsNotificationBannerContext = React.createContext<TranslationsNotificationBannerContextType>({
  showBanner: false,
  setHideBanner: () => {},
  openDialog: () => {},
  productType: '',
  subfolderLanguage: '',
  hasTranslations: false,
});

export const useTranslationsNotificationBanner = () => {
  const context = useContext(TranslationsNotificationBannerContext);
  if (!context) {
    throw new Error('useTranslationsNotificationBanner must be used within a TranslationsNotificationBannerProvider');
  }
  return context;
};

export default TranslationsNotificationBannerContext;
